import { createSlice } from "@reduxjs/toolkit"

import { Invoice } from "../../../model/billing"

import { fetchInvoiceHistory, getOutstandingBalancebyOrg } from "./billingThunk"

interface Billing {
  outstandingBalance: null | number
  invoices: Invoice[]
  loading: "idle" | "pending" | "succeeded" | "failed"
  // org the cached data above belongs to, used to detect an org switch
  orgId: string | null
}
const initialState: Billing = {
  loading: "idle",
  outstandingBalance: null,
  invoices: null,
  orgId: null,
}

export const BillingServiceSlice = createSlice({
  name: "billingService",
  initialState,
  reducers: {
    resetBillingState(state) {
      // must be null, not [] - BillingModule checks !invoices to refetch
      state.invoices = null;
      state.outstandingBalance = null;
    },
    setBillingOrgId(state, action: { payload: string }) {
      state.orgId = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getOutstandingBalancebyOrg.pending, (state) => {
      state.loading = "pending"
    })
    builder.addCase(getOutstandingBalancebyOrg.fulfilled, (state, action) => {
      state.outstandingBalance = action?.payload?.data?.result?.balance
      state.loading = "succeeded"
    })
    builder.addCase(getOutstandingBalancebyOrg.rejected, (state) => {
      state.loading = "failed"
    })
    builder.addCase(fetchInvoiceHistory.pending, (state) => {
      state.loading = "pending"
    })
    builder.addCase(fetchInvoiceHistory.fulfilled, (state, action) => {
      if (state?.invoices?.length && action?.payload) {
        state.invoices.push(...action.payload.reverse())
      } else {
        state.invoices = action?.payload?.reverse()
      }
      state.loading = "succeeded"
    })

    builder.addCase(fetchInvoiceHistory.rejected, (state) => {
      state.loading = "failed"
    })
  },
})

export const { resetBillingState, setBillingOrgId } = BillingServiceSlice.actions;
